import React, { useState } from "react";
import { HeaderList } from '../HeaderList';
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../utils/cookie";
import { indigo } from '@mui/material/colors';
import PersonIcon from '@mui/icons-material/Person';
import LogoImg from '../../assets/home/bacchusdrinks-logo-header.svg';
import chart from '../../assets/home/korpa.svg';
import { 
    Navigation,
    HeaderItemWrapper,
    HeaderItem,
    Img
} from './styles';
import LanguageSelect from "../LanguageSelect";
import { useTranslation } from "react-i18next";

const DesktopMenu = (props) => {
    const navigate = useNavigate();
    const [chartStorage] = useState(getCookie('cart'));
    const [isLoggedIn] = useState(getCookie('token'));
    const [isAdmin] = useState(getCookie('isAdmin') === 'true');
    const { t } = useTranslation();

    const redirecting = (route) => {
        if(route === '/') return navigate("/");
        if(route === '/shop') return navigate("/shop");
        if(route === '/privacy-policy') return navigate("/privacy-policy");
        if(route !== '/') {
            navigate("/")
            setTimeout(() => {
                document.getElementById(route).scrollIntoView();
            }, 0)
            return;
        };
    }

    return(
        <Navigation single={props.single}>
            <HeaderItemWrapper>
                <Img src={LogoImg} onClick={() => navigate("/")} />
            </HeaderItemWrapper>
            <HeaderItemWrapper>
                {
                    [HeaderList.map(item => (
                        item.name !== 'privacy policy' && <HeaderItem key={item.id} onClick={() => redirecting(item.route)}>{t(item.name)}</HeaderItem>
                    )), 
                    isAdmin && <HeaderItem key={'admin-panel'} onClick={() => navigate('/admin-panel')}>{t('adminPanel')}</HeaderItem>
                    ]
                }
            </HeaderItemWrapper>
            <HeaderItemWrapper>
                {isLoggedIn ?
                    <PersonIcon 
                        onClick={() => navigate('/profile')}
                        style={{ cursor: 'pointer', marginRight: '15px' }}
                        sx={{
                            fontSize: "28px",
                            color: indigo[50],
                        }}
                        />
                    :
                    <HeaderItem onClick={() => navigate('/login')}>{t('login')}</HeaderItem>
                }
                <LanguageSelect/>
                {chartStorage && 
                    <Img src={chart} small onClick={() => navigate('/chart')}/>
                }
            </HeaderItemWrapper>
        </Navigation>
    )
}
export default DesktopMenu;
